import CutwiseAPIClient, { HEADER_X_TOTAL_COUNT, METHOD_DELETE, METHOD_GET, METHOD_PATCH, METHOD_PUT, } from '@/common/network/CutwiseAPIClient';
export const PATH_SECURITY_ACCESS = 'api/security/access';
export const PATH_SECURITY_ACL_V3 = 'api/v3/security/acl';
export default class SecurityAPI {
    async getAssignees(searchQuery, offset = null, limit = null) {
        const qb = CutwiseAPIClient.createQueryBuilder()
            .method(METHOD_GET)
            .path(`${PATH_SECURITY_ACL_V3}/search`)
            .offset(offset)
            .limit(limit)
            .addQueryStringParam('searchQuery', searchQuery);
        const res = await CutwiseAPIClient.sendQuery(qb.getQuery());
        return {
            assignees: res.content,
            totalCount: res.networkResponse?.headers.get(HEADER_X_TOTAL_COUNT),
        };
    }
    async getAccessEntries(ids, targetType) {
        const qb = CutwiseAPIClient.createQueryBuilder()
            .method(METHOD_GET)
            .path(`${PATH_SECURITY_ACL_V3}/${targetType}`)
            .addQueryStringParam('id', ids);
        const res = await CutwiseAPIClient.sendQuery(qb.getQuery());
        return res.content;
    }
    updateAccess(data) {
        const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_PATCH).path(PATH_SECURITY_ACCESS).body(data);
        return CutwiseAPIClient.sendQuery(qb.getQuery());
    }
    async updateACL(accessRequests) {
        const qb = CutwiseAPIClient.createQueryBuilder()
            .method(METHOD_PUT)
            .path(PATH_SECURITY_ACL_V3)
            .body({ aclRequests: accessRequests.map((request) => request.toDto()) });
        const res = await CutwiseAPIClient.sendQuery(qb.getQuery());
        return res.content;
    }
    async deleteACL(accessRequests) {
        const body = accessRequests.map((request) => request.toDto());
        const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_DELETE).path(PATH_SECURITY_ACL_V3).body(body);
        const res = await CutwiseAPIClient.sendQuery(qb.getQuery());
        return res.content;
    }
}
